import React, { AriaAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { BiData, WatchFilterSearchBiEvent } from '@wix/da-bi/pkg/events';

export interface Props {
  value?: string;
  className?: string;
  onChange?: (value: string, event?: any) => void;
  'aria-autocomplete'?: AriaAttributes['aria-autocomplete'];
  'aria-activedescendant'?: AriaAttributes['aria-activedescendant'];
  'aria-controls'?: AriaAttributes['aria-controls'];
}

const UserInput: React.FC<Props> = ({
  value = '',
  onChange,
  className,
  'aria-autocomplete': ariaAutocomplete,
  'aria-activedescendant': ariaActiveDescendant,
  'aria-controls': ariaControls,
}) => {
  const { t } = useTranslation();
  return (
    <TextInput
      id="deviant-list-user-input"
      value={value}
      onChange={ev => onChange && onChange(ev.target.value, ev)}
      className={className}
      placeholder={t('deviantList.input.filter.placeholder')}
      prefix={<SearchIcon />}
      aria-autocomplete={ariaAutocomplete}
      aria-activedescendant={ariaActiveDescendant}
      aria-controls={ariaControls}
      biData={BiData<WatchFilterSearchBiEvent>({
        evid: 410,
      } as any)}
      label={t('deviantList.input.filter.placeholder')}
      isLabelHidden
    />
  );
};
UserInput.displayName = 'UserInput';

export default UserInput;
